import PropTypes from 'prop-types';
import { createContext, useCallback, useContext, useMemo, useState } from 'react';

// ----------------------------------------------------------------------

const OrderingV2UiContext = createContext(null);

export function OrderingV2UiProvider({ children }) {
  const [cartDrawerOpen, setCartDrawerOpen] = useState(false);
  const [detailProduct, setDetailProduct] = useState(null);
  const [menuLocation, setMenuLocation] = useState(null);
  const [storyState, setStoryState] = useState(null);
  const [crossSellProducts, setCrossSellProducts] = useState([]);

  const openCart = useCallback(() => setCartDrawerOpen(true), []);
  const closeCart = useCallback(() => setCartDrawerOpen(false), []);
  const toggleCart = useCallback(() => setCartDrawerOpen((o) => !o), []);

  const openProductDetail = useCallback((product) => setDetailProduct(product), []);
  const closeProductDetail = useCallback(() => setDetailProduct(null), []);

  const openStory = useCallback((groupId) => setStoryState({ groupId, slideIndex: 0 }), []);
  const closeStory = useCallback(() => setStoryState(null), []);
  const setStorySlide = useCallback((slideIndex) => {
    setStoryState((s) => (s ? { ...s, slideIndex } : null));
  }, []);

  const value = useMemo(
    () => ({
      cartDrawerOpen,
      setCartDrawerOpen,
      openCart,
      closeCart,
      toggleCart,
      detailProduct,
      openProductDetail,
      closeProductDetail,
      menuLocation,
      setMenuLocation,
      storyState,
      openStory,
      closeStory,
      setStorySlide,
      crossSellProducts,
      setCrossSellProducts,
    }),
    [
      cartDrawerOpen,
      closeCart,
      closeProductDetail,
      closeStory,
      crossSellProducts,
      detailProduct,
      menuLocation,
      openCart,
      openProductDetail,
      openStory,
      setStorySlide,
      storyState,
      toggleCart,
    ]
  );

  return <OrderingV2UiContext.Provider value={value}>{children}</OrderingV2UiContext.Provider>;
}

OrderingV2UiProvider.propTypes = {
  children: PropTypes.node,
};

export function useOrderingV2Ui() {
  const ctx = useContext(OrderingV2UiContext);
  if (!ctx) {
    throw new Error('useOrderingV2Ui must be used within OrderingV2UiProvider');
  }
  return ctx;
}
